import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import { CsvToIntArray } from '../../../helpers/strings';
import '../Reports.scss';

export class SupportTicketsFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            agentIds: '',
            supportTicketStatusIds: '1,2'
        }

        this.state = {
            emptyForm: initialFormSelections,
            agentIds: initialFormSelections.agentIds,
            supportTicketStatusIds: initialFormSelections.supportTicketStatusIds
        }
    }

    componentDidMount = async () => {
        /**
         * Must set defaults before registering report filter functions, because
         * these defaults might be overridden by mapToForm values coming from
         * the API when opening a scheduled report.
         */
        this.setDefaults();
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
    }

    setDefaults = () => {
        let newState = { ...this.state };

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,
                agentIds: appState.agentIds ? appState.agentIds : newState.agentIds,
                supportTicketStatusIds: appState.supportTicketStatusIds ? appState.supportTicketStatusIds : newState.supportTicketStatusIds,
            }
        }

        this.setState({
            ...this.state,
            ...newState
        });
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        return true;
    }

    mapToForm = (reportRequest) => {
        const form = { ...this.state.emptyForm };

        form.agentIds = (reportRequest.agentIds) ? reportRequest.agentIds.join(',') : form.agentIds;
        form.supportTicketStatusIds = (reportRequest.supportTicketStatusIds) ? reportRequest.supportTicketStatusIds.join(',') : form.supportTicketStatusIds;

        this.setState({
            ...this.state,
            ...form
        });
    }

    mapToApiRequest = () => {

        const request = {
            reportId: this.props.report.id,
            supportTicketStatusIds: CsvToIntArray(this.state.supportTicketStatusIds),
            agentIds: CsvToIntArray(this.state.agentIds)
        };

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onFieldChange = (name, value) => {
        this.setState({ ...this.state, [name]: value });
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    render() {

        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="supportTicketStatusIds"
                            label="Status" idField="id" valueField="name"
                            options={this.props.filters.ticketStatuses}
                            selectedValues={this.state.supportTicketStatusIds.toString()}
                            onChange={this.onDropdownChange}
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="agentIds"
                            label="Agents" idField="id" valueField="name"
                            options={this.props.filters.agents}
                            selectedValues={this.state.agentIds.toString()}
                            onChange={this.onDropdownChange}
                            isMulti={true} />
                    </div>
                </div>
            </form>
        );
    }
}

SupportTicketsFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired,
    savedFilterValues: PropTypes.object.isRequired
};

export default SupportTicketsFilters;